import { Pipe, PipeTransform } from '@angular/core';
import { InstallationEquipmentInfoPluginService } from './equipment-info.service';

@Pipe({
    name: 'supplier',
    standalone: false
})
export class SupplierPipe implements PipeTransform {
  public suppliers: any[];

  constructor(private service: InstallationEquipmentInfoPluginService) {
    this.suppliers = this.service.getSuppliers();
  }

  transform(id: string): any {
    return this.service.getValue(parseInt(id), this.suppliers);
  }
}
